<template>
  <b-form @submit.prevent="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>{{ file.legenda }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="$routeBack('files_list')"
              class="btn btn-outline-muted mr-2"
            >
              Voltar
            </router-link>
          </div>
        </div>
      </template>

      <div class="p-4">
        <b-row>
          <b-col cols="11">
            <b-form-group label="Legenda">
              <b-input v-model="file.legenda" placeholder="Legenda" />
            </b-form-group>
          </b-col>
          <b-col cols="1" class="d-flex align-items-center">
            <div class="table-actions">
              <b-button
                v-if="isImage"
                variant="outline-info"
                @click="openPreview = true"
                ><font-awesome-icon icon="eye"
              /></b-button>

              <b-button v-else @click="visualizar()" variant="outline-info">
                <font-awesome-icon icon="download" />
              </b-button>
            </div>
          </b-col>
        </b-row>

        <image-preview
          :show="openPreview"
          @close="openPreview = false"
          thumbnail
          :src="file.url"
        />

        <b-row>
          <b-col>
            <b-form-group label="Categoria">
              <select-file-categoria
                v-model="file.file_categoria_id"
                placeholder="Nome"
              />
            </b-form-group>
            <b-form-group label="Tags">
              <list-tags v-model="file.tags" class="border-0"></list-tags>
            </b-form-group>
            <b-form-group label="Descrição">
              <b-form-textarea
                v-model="file.descricao"
                placeholder="descrição"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <select-file-estrutura
              v-model="file.file_folder_id"
            ></select-file-estrutura>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </b-form>
</template>

<script>
import ImagePreview from "@/modules/files/Components/ImagePreview.vue";
import ListTags from "@/modules/files/Components/Form/ListTags.vue";
import SelectFileCategoria from "@/modules/files/Components/SelectFileCategoria.vue";
import SelectFileEstrutura from "@/modules/files/Components/SelectFileEstrutura.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [validationMixin],
  components: {
    ImagePreview,
    ListTags,
    SelectFileCategoria,
    SelectFileEstrutura,
  },
  data: () => ({
    openPreview: false,
  }),
  validations: {
    file: {
      legenda: required,
    },
  },
  computed: {
    ...mapState("files", ["file"]),
  },
  methods: {
    ...mapActions("files", ["ActionSave", "ActionsDownload"]),
    loadData(id) {
      this.$router.push({ name: "files_edit", params: { id: id } });
    },
    validImageExtension(ext = "") {
      const imageExtensions = [/png/, /jpg/, /jpeg/, /gif/, /bmp/];
      return imageExtensions.some((extension) => extension.test(ext));
    },
    isImage() {
      const extensionFormated = this.filte.extra_data.extension.replace(
        ".",
        ""
      );
      return this.validImageExtension(extensionFormated);
    },
    visualizar() {
      this.ActionsDownload(this.file);
    },
    async onSubmit(evt) {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return;
      }
      try {
        await this.ActionSave(this.file);
        this.$emit("saved", this.file.id);

        this.$notifications.addNotification({
          message: "Registro salvo com sucesso",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        this.$notifications.addNotification({
          message: "Erro ao salvar",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    isValid() {
      this.$v.file.$touch();
      return !this.$v.file.$anyError;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.file[name];
      return $dirty ? !$error : null;
    },
  },
  async created() {},
};
</script>

<style></style>
